import type { KlingVideoResolution } from '@/types/chat';

export const GV_OMNI_RESOLUTIONS = ['720P', '1080P'] as const satisfies readonly KlingVideoResolution[];

export type GvOmniResolution = (typeof GV_OMNI_RESOLUTIONS)[number];

export function isGvOmniResolution(value: KlingVideoResolution): value is GvOmniResolution {
  return GV_OMNI_RESOLUTIONS.includes(value as GvOmniResolution);
}

export function requireGvOmniResolution(resolution: KlingVideoResolution): GvOmniResolution {
  if (!isGvOmniResolution(resolution)) {
    throw new RangeError(`GV Omni resolution must be 720P or 1080P, received ${resolution}`);
  }
  return resolution;
}
